// src/components/Navbar/NavbarMobile.js
import React, { useState } from "react"
import {
  Box,
  IconButton,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Badge,
  Divider,
  ListItemIcon
} from "@mui/material"
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart"
import MenuIcon from "@mui/icons-material/Menu"
import AccountCircleIcon from "@mui/icons-material/AccountCircle"
import LoginOutlined from "@mui/icons-material/LoginOutlined"
import Search from "./Search"

export default function NavbarMobile({
  cartCount,
  showLogged,
  isActive,
  navigate,
  onLogin,
  onLogout,
  onAccount
}) {
  const [open, setOpen] = useState(false)
  const toggle = (v) => () => setOpen(v)

  return (
    <>
      <button className="menu-trigger" aria-label="Abrir menú" onClick={toggle(true)}>
        <MenuIcon />
        <span className="menu-word">MENÚ</span>
      </button>

      <Drawer anchor="left" open={open} onClose={toggle(false)}>
        <Box sx={{ width: 300 }} role="presentation">
          <Box className="drawer-top-icons">
            <IconButton
              aria-label="Carrito"
              onClick={() => {
                navigate("/shop")
                setOpen(false)
              }}
            >
              <Badge badgeContent={cartCount} color="error">
                <ShoppingCartIcon />
              </Badge>
            </IconButton>
            {!showLogged && (
              <IconButton
                aria-label="Iniciar sesión"
                onClick={() => {
                  onLogin()
                  setOpen(false)
                }}
              >
                <LoginOutlined />
              </IconButton>
            )}
          </Box>

          <Divider />

          <List>
            <ListItemButton
              selected={isActive("/")}
              onClick={() => {
                navigate("/")
                setOpen(false)
              }}
              sx={{
                "&.Mui-selected": { backgroundColor: "#000" },
                "&.Mui-selected .MuiListItemText-primary": { color: "#ff6700" }
              }}
            >
              <ListItemText primary="Inicio" />
            </ListItemButton>

            <ListItemButton
              selected={isActive("/acerca-de-nosotros")}
              onClick={() => {
                navigate("/acerca-de-nosotros")
                setOpen(false)
              }}
              sx={{
                "&.Mui-selected": { backgroundColor: "#000" },
                "&.Mui-selected .MuiListItemText-primary": { color: "#ff6700" }
              }}
            >
              <ListItemText primary="Nosotros" />
            </ListItemButton>

            <ListItemButton
              selected={isActive("/servicios")}
              onClick={() => {
                navigate("/servicios")
                setOpen(false)
              }}
              sx={{
                "&.Mui-selected": { backgroundColor: "#000" },
                "&.Mui-selected .MuiListItemText-primary": { color: "#ff6700" }
              }}
            >
              <ListItemText primary="Servicios" />
            </ListItemButton>

            <ListItemButton
              selected={isActive("/categorias")}
              onClick={() => {
                navigate("/categorias")
                setOpen(false)
              }}
              sx={{
                "&.Mui-selected": { backgroundColor: "#000" },
                "&.Mui-selected .MuiListItemText-primary": { color: "#ff6700" }
              }}
            >
              <ListItemText primary="Tienda" />
            </ListItemButton>

            <ListItemButton
              selected={isActive("/contacto")}
              onClick={() => {
                navigate("/contacto")
                setOpen(false)
              }}
              sx={{
                "&.Mui-selected": { backgroundColor: "#000" },
                "&.Mui-selected .MuiListItemText-primary": { color: "#ff6700" }
              }}
            >
              <ListItemText primary="Contacto" />
            </ListItemButton>
          </List>

          {showLogged && (
            <>
              <Divider />
              <List>
                <ListItemButton
                  onClick={() => {
                    onAccount()
                    setOpen(false)
                  }}
                >
                  <ListItemIcon>
                    <AccountCircleIcon />
                  </ListItemIcon>
                  <ListItemText primary="Mi Cuenta" />
                </ListItemButton>
                <ListItemButton
                  onClick={async () => {
                    await onLogout()
                    setOpen(false)
                  }}
                >
                  <ListItemText primary="Cerrar Sesión" />
                </ListItemButton>
              </List>
            </>
          )}
        </Box>
      </Drawer>
    </>
  )
}

export function MobileSearch() {
  return (
    <div className="nav-search mobile" style={{ width: "100%" }}>
      <Search isMobile />
    </div>
  )
}
